import MaterialTable from "@material-table/core";
import { log } from "../../../Helper";

export const SubmittedQuoteSelectedTable = (props) => {

  const { selectedMachineForQuote } = props;

  const columns = [
    {
        title: "OrderPath Id",
        field: "orderPathId",
        sorting: true,
        hidden: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Comar",
        field: "comar",
        sorting: false,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Pick-Up",
        field: "pickLocation",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Destination",
        field: "shipDestination",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Product",
        field: "productDescription",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "DIM (meter)",
        field: "dimension",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Start Date",
        field: "startDate",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Due Date",
        field: "expectedDate",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Serial",
        field: "serialNumber",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Providers",
        field: "providerList",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Quoted",
        field: "quotedFlag",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
];

  return (
    <div className="mt-n2">
        {log("final data : ", selectedMachineForQuote)}
      <MaterialTable
        options={{
          rowStyle: {
            fontSize: 9,
          },
          selection: false,
          search: false,
          toolbar:false,
          showTitle: false,
          sorting: false,
          paging: false,
          draggable: false,
          headerStyle: {
            backgroundColor: "#367c2b",
            fontWeight: "200",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          tableContainerStyle: {
            overflow: "auto",
          },
          filterCellStyle: {
            flex: 1
          },
        }}
        columns={columns}
        data={selectedMachineForQuote}
      />
      <br />

    </div>
  );
};
